"use client";
import React, { useEffect, useState } from "react";
import { decode } from "html-entities";
import { baseUrl } from "@/utils/api-definition";
import { v4 as uuidv4 } from "uuid";
import Script from "next/script";
import { useXNoticeStore } from "@/components/context/xnotice-store";
import extractScripts from "@/utils/extract-scripts";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Cookies from "js-cookie";
function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}
function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
const XNoticeContent: React.FC<{ settings: any }> = ({ settings = {} }) => {
  const { notices } = useXNoticeStore();
  const [cssScripts, setCssScripts] = useState<any[]>([]);
  const [jsScripts, setJsScripts] = useState<any[]>([]);
  const [customHTML, setCustomHTML] = useState<any[]>([]);
  const [customScripts, setCustomScripts] = useState<any[]>([]);

  function addScripts(notice: any) {
    const { html, scripts } = extractScripts(notice.html);
    setCustomScripts((oldArray) => [...oldArray, ...scripts]);
    if (notice.settings.layout) {
      setCssScripts((oldArray) => [...oldArray, notice.settings.layout]);
    }
    if (notice.settings.js) {
      setJsScripts((oldArray) => [...oldArray, notice.settings.js]);
    }

    return html;
  }

  useEffect(() => {
    setCssScripts([]);
    setCustomScripts([]);
    setJsScripts([]);
    setCustomHTML([]);
    const closedNotices = Cookies.get("closed-notices");
    const noticesArray = closedNotices ? JSON.parse(closedNotices) : [];
    notices.forEach((notice: any) => {
      if (!noticesArray.includes(notice.id)) {
        let procesingHtml = "";
        let className = `notice-${notice.theme.name}`;
        if (settings.selector === notice.selector) {
          procesingHtml += addScripts(notice);
        } else if (settings.sticky && notice.settings.type === "sticky") {
          if (settings.position === notice.settings.position) {
            procesingHtml += addScripts(notice);
            className += ` ${notice.settings.type}-${notice.settings.position}`;
          }
        }
        if (procesingHtml) {
          className += ` text-${notice.settings.align}`;
          procesingHtml = replaceAll(procesingHtml, ' src="/', ' src="' + baseUrl + "/");
          setCustomHTML((oldArray) => [
            ...oldArray,
            {
              id: notice.id,
              html: procesingHtml,
              classname: className,
              close: notice.settings.close,
              align: notice.settings.align,
            },
          ]);
        }
      }
    });
  }, [notices]);
  const handleRemove = (id: string) => {
    const closedNotices = Cookies.get("closed-notices");
    const noticesArray = closedNotices ? JSON.parse(closedNotices) : [];
    noticesArray.push(id);
    Cookies.set("closed-notices", JSON.stringify(noticesArray));
    setCustomHTML((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    customHTML && (
      <div key={uuidv4()}>
        <Box>
          {cssScripts.length > 0 &&
            cssScripts.map((style) => <style key={uuidv4()}>{decode(style)}</style>)}
          {jsScripts.length > 0 &&
            jsScripts.map((script) => (
              <Script key={uuidv4()} id={uuidv4()} strategy="afterInteractive">
                {script}
              </Script>
            ))}
        </Box>
        {customScripts.map((script: any) => {
          if (script.src) {
            return (
              <Script src={script.src} id={uuidv4()} key={uuidv4()} strategy="afterInteractive" />
            );
          } else {
            return (
              <Script id={uuidv4()} key={uuidv4()} strategy="afterInteractive">
                {script.content}
              </Script>
            );
          }
        })}
        {customHTML.map((html: any) => {
          return (
            <Box key={html.id} className="relative" sx={{ textAlign: html.align }}>
              {html.close && (
                <IconButton
                  onClick={() => handleRemove(html.id)}
                  aria-label="close"
                  disableRipple
                  size="small"
                  style={{ position: "absolute", top: 0, right: 0, zIndex: 205 }}
                >
                  <CloseIcon />
                </IconButton>
              )}
              <div
                className={html.classname}
                dangerouslySetInnerHTML={{
                  __html: decode(html.html),
                }}
              ></div>
            </Box>
          );
        })}
      </div>
    )
  );
};
export default XNoticeContent;
